exports.wrapPageElement = require(`./src/gatsby`).wrapRootElement
